export default __webpack_public_path__ + "static/media/placeholder.2cf8a335.jpg";